/*{categories: climbing, hochtourEast, hoochtourWEst, skitour}*/

const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;

const offers = [
  {
    id: "m1",
    category: "climbing",
    country: "Österreich",
    title: "Traunspitzl Westwand",
    subtitle:
      "Einsame Klettertour eingebettet in märchenhafte Landschaftsreise.",
    text_overview:
      "Einer der schönsten Kletterplätze der nördlichen Kalkalpen befriedigt mit etwas Gebietskennen jedes Kletterherz. Je nach Wunsch finden wir kurze oder längere Klettereien mit kürzerem oder längerem Zustieg in sonniger oder schattiger Umgebung.",
    text_itinerary:
      "Wir treffen uns am Parkplatz am Fuße der Loferer Steinberge und steigen auf zur Märchenwiese, einem einsamen Kleinod inmitten steiler Felsabbrüche. Wenn man weiß wo dann finden sich in den Steinbergen steile und nach Wunsch anspruchsvolle alpine Klettertouren in perfektem Fels. Wir befinden uns an einem dieser Orte und alternativ können je nach Tagesverfassung leichtere oder schwerer Touren in allen Schwierigkeitsgraden und Längen gewählt werden.",
    price: "ab € 450,00",
    prices: {
      1: "450,00", 
      2: "550,00"  
    },
    inclServices: ["Führung durch staatlich geprüften Bergführer."],
    exclServices: "Ausrüstung (Leihausrüstung nach Bedarf)",
    equipment: "Kletterschuhe",
    date: "Spontan nach Anfrage.",
    place: "Loferer Steinberge, Salzburg",
    maxGuests: "2",
    overalleLevel: 3,
    levelTech: 33, 
    levelTechText: "Sicheres Klettern im 6. Grad im Nachstieg",
    levelFitness: 33, 
    levelFitnessText:"Ausgefüllter Tag mit langem schönem Zustieg",
    
    link: "/mountainguide",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m1_Traunspitzl_Neue_Zeiten/head.jpg`,
    imgOne: `${baseImagePath}mountainguide/offers/m1_Traunspitzl_Neue_Zeiten/IMG_7516.jpg`,
    imgTwo: `${baseImagePath}mountainguide/offers/m1_Traunspitzl_Neue_Zeiten/IMG_7575.jpg`,
    imgThree: `${baseImagePath}mountainguide/offers/m1_Traunspitzl_Neue_Zeiten/IMG_7535.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },

  {
    id: "m2",
    category: "climbing",
    country: "Österreich",
    title: "Freier als Paul Preuß, Hochkönig",
    subtitle:
      "Eine der berühmtesten Felsklettereien Österreichs.",
    text_overview:
      "Über Almböden geht es zum Einstieg dieses modernen Extremklassikers, einer Hommage an den Freikletterpionier Paul Preuß von Albert Precht. Die Wand ist allen einheimischen Kletterern ein Begriff und bietet mit dieser Tour einen der längsten und anspruchsvollsten Anstiege in einem Schwierigkeitsgrad der gerade noch zugänglich ist. Die Eckdaten sprechen für sich: 28 Seillängen und eine Wandhöhe von fast 1000 Meter durch einen durchgehend steilen Plattenpanzer der nur wenige Schwachstellen für einen Durchstieg aufweist.",
    text_itinerary:
      "Noch vor Einbruch der Dämmerung starten wir den knapp zweistündigen und relativ komplizierten Zustieg. Einmal eingestiegen wartet nach ein paar Seillängen das Herzstück der Tour, ein spannender Quergang der unvermittelt die große Exposition spüren lässt. Steil und anhaltend geht es aufwärts bevor die Tour in einem spannenden Finale endet. Spätabends beenden wir den langen Abstieg zum Auto zurück.",
    price: "ab € 750,00",
    prices: {
      1: "750,00", 
      2: "900,00"  
    },
    inclServices: ["Führung durch staatlich geprüften Bergführer."],
    exclServices: ["Ausrüstung (Leihausrüstung nach Bedarf)"],
    equipment: "Kletterschuhe",
    date: "Spontan nach Anfrage im Herbst.",
    duration: "1 Tag",
    place: "Hochkönig, Salzburg",
    maxGuests: "2",
    overalleLevel: 4,
    levelTech: 44,
    levelTechText: "Sicheres Klettern im oberen 6. Grad im Nachstieg",
    levelFitness: 44,
    levelFitnessText: "Große Wand in Kombination mit langem Zu- und Abstieg",
    link: "/mountainguide",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m2_Paul_Preuss/head.jpg`,
    imgOne: `${baseImagePath}mountainguide/offers/m2_Paul_Preuss/IMG_4009.jpg`,
    imgTwo: `${baseImagePath}mountainguide/offers/m2_Paul_Preuss/IMG_4026.jpg`,
    imgThree: `${baseImagePath}mountainguide/offers/m2_Paul_Preuss/IMG_4038.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },
  {
    id: "m3",
    category: "climbing",
    country: "Österreich",
    title: "Totenkirchl Westwand 'Dülfer'",
    subtitle:
      "Geschichtsträchtiger Extremklassiker von früher.",
    text_overview:
      "Herrn Dülfer vorzustellen ist vermutlich nicht nötig und hier hat er eines seiner denkwürdigsten Meisterwerke hinterlassen. Zur Zeit der Erstbegehung galt dies als eine der schwersten Alpenwände. Auch heute zollen Aspiranten noch Respekt bezüglich der Linienführung und Wandhöhe. Nach einem klettertechnisch nicht sonderlich schweren aber bergsteigerisch sehr spannendem Start steilt die Wand auf und es warten typische Kaiser-Felspanzer, die an einer Stelle den berühmten Dülfer-Quergang erzwingen.",
    text_itinerary:
      "Wir treffen uns am Ausgangsparkplatz, erwandern das Stripsenjochhaus und 45 Minuten später den Einstieg. Die Tour ist bezüglich Orientierung und Sicherungstechnik relativ anspruchsvoll und wir werden genug Zeit haben die Exposition aufzusaugen. Ein interessanter Abstieg runden das Erlebnis Klettern am Wilden Kaiser ab.",
    price: "ab € 690,00",
    prices: {
      1: "690,00", 
      2: "790,00"  
    },
    inclServices: ["Führung durch staatlich geprüften Bergführer."],
    exclServices: ["Ausrüstung (Leihausrüstung nach Bedarf)"],
    equipment: "Kletterschuhe",
    date: "Spontan nach Anfrage im Herbst.",
    duration: "1 Tag",
    place: "Wilder Kaiser, Salzburg",
    maxGuests: "2",
    overalleLevel: 3,
    levelTech: 44,
    levelTechText: "Sicheres Klettern im oberen 6. Grad im Nachstieg",
    levelFitness: 33,
    levelFitnessText: "Ausgefüllter Tag mit langem schönem Zustieg",
    link: "/mountainguide",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m3_Duelfer/head.jpg`,
    imgOne: `${baseImagePath}mountainguide/offers/m3_Duelfer/IMG_3918.jpg`,
    imgTwo: `${baseImagePath}mountainguide/offers/m3_Duelfer/IMG_3957.jpg`,
    imgThree: `${baseImagePath}mountainguide/offers/m3_Duelfer/IMG_1156.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },
  {
    id: "m4",
    category: "climbing",
    country: "Österreich",
    title: "Fleischbank 'Via Classica'",
    subtitle: "Kennenlern-Nordwandtour mit vergleichsweise geringem Anspruch.",
    text_overview:
      "Große Nordwände brechen meist steil und unwirtlich in die Tiefe, wirken einschüchternd und unnahbar. Kaum verwunderlich, dass viele der großen und berüchtigten Alpenklettereien durch Nordwände führen. Diese Genusskletterei im Wilden Kaiser führt durch eben eine solche, kühl, zerklüftet und steil - kaum zu glauben dass hier 'nur' der 5. Grad gefordert wird. Die Felsqualität keine Wünsche offen und die Standplätze sind perfekt eingerichtet, was die objektiven Gefahren gering hält.",
    text_itinerary:
      "Wir brechen früh genug am hoch gelegenen Parkplatz auf um die Sonne an den Ostwänden der Fleischbank alpenglühen zu lassen. Danach verstecken wir uns eine Weile in den tiefen Winkeln des Berges und klettern eine logische und ansprechende Line durch Kamine, Schluchten und Wänden bevor wir am spitzen Gipfel wieder die Rundumsicht genießen können. Ein typisch exponierter Kaiser-Abstieg bringt uns zurück zum Auto.",
    price: "ab € 450,00",
    prices: {
      1: "450,00", 
      2: "550,00"  
    },
    inclServices: ["Führung durch staatlich geprüften Bergführer."],
    exclServices: ["Ausrüstung (Leihausrüstung nach Bedarf)"],
    equipment: "",
    date: "Spontan nach Anfrage im Sommer und Herbst.",
    duration: "1 Tag",
    place: "Wilder Kaiser, Tirol",
    maxGuests: "2",
    overalleLevel: 2,
    levelTech: 22, 
    levelTechText: "Sicheres Klettern im 5. Grad im Nachstieg",
    levelFitness: 22,
    levelFitnessText: "Alpine Kletterroute",
    link: "/avalanches",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m4 _viaClassica/head.jpg`,
    imgOne: `${baseImagePath}mountainguide/offers/m4 _viaClassica/IMG_8149.jpg`,
    imgTwo: `${baseImagePath}mountainguide/offers/m4 _viaClassica/IMG_8169.jpg`,
    imgThree: `${baseImagePath}mountainguide/offers/m4 _viaClassica/IMG_8176.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },
  {
    id: "m5",
    category: "skitour",
    title: "Freeriden Saalbach-Hinterglemm",
    subtitle: "Die besten Abfahrten zur besten Zeit im Schizirkus Saalbach-Hinterglemm-Leogang-Fieberbrunn.",
    text_overview: "Das Glemmtal beheimatet eines der größten Schigebiete Österreichs, und dementsprechend viel Platz ist auch neben den Pisten. Weite Teile sind nicht durch Lifte erschlossen können aber mit kurzen Aufstiegen erreicht werden und so wartet eine große weiße Landkarte durch die wir unsere Linien ziehen.",
    text_itinerary: "Wir treffen uns bei einem der Tallifte und verbringen den ganzen Tag im Schigebiet. Wir kennen alle Runs und reagieren flexibel auf die Verhältnisse, und so werden wir unsere Runde durchs Glemmtal ziehen. Auch wenn der Schnee einmal nicht perfekt ist finden wir den besten den es gibt.",
    price: "ab € 450,00",
    prices: {
      1: "450,00",
      2: "450,00",
      3: "550,00",
      4: "550,00",
      5: "550,00"
    },
    inclServices: [
      "Führung im freien Gelände durch staatlich geprüften Berg- und Schiführer, Landesskilehrer und Lawinenfachmann.",
    ], 
    exclServices: [
      "Liftkarten", 
      "Schiausrüstung",
      "Einkehr"
    ],
    equipment: "",
    date: "Spontan nach Anfrage im Winter.",
    duration: "1 Tag",
    place: "Saalbach-Hinterglemm, Salzburg",
    maxGuests: "5",
    overalleLevel: 1,
    levelTech: 22,
    levelTechText: "Etwas Erfahrung mit Schifahren im Gelände",
    levelFitness: 11, 
    levelFitnessText: "Freeriden mit kleinen Anstiegen nach Wunsch",
    link: "/mountainguide",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m5_freeride_saalbach/head.jpg`,
    imgOne: `${baseImagePath}mountainguide/offers/m5_freeride_saalbach/IMG_3636.jpg`,
    imgTwo: `${baseImagePath}mountainguide/offers/m5_freeride_saalbach/IMG_8320.jpg`,
    imgThree: `${baseImagePath}mountainguide/offers/m5_freeride_saalbach/IMG_8208.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },

  {
    id: "m6",
    category: "skitour",
    country: "Österreich",
    title: "Schitour auf die Hocheisspitze",
    subtitle: "Die Hocheisspitze liegt genau an der Grenze zwischen Salzburg und Berchtesgaden und bietet ein unübliches aber interessantes Schiziel.",
    text_overview: "Die Hocheisspitze steht für eine Reihe an Gipfeln der nördlichen Kalkalpen die man nicht auf den ersten Blick als Schiberg identifiziert, die aber am richtigen Tag wunderschöne und einsame Erlebnisse darbieten. Oft eingebettet inmitten lieblicher Almen und schroffer Felsabbrüche ist der Anspruch etwas höher als in den Grasbergen, die erreichten Gipfel aber dafür umso erfüllender.",
    text_itinerary: "Treffpunkt ist am Ausgangspunkt der Tour, der uns glücklicherweise schon einige Höhenmeter abnimmt. Durch weite Kare, einmal unterbrochen durch eine kleine Steilstufe, geht es zum Gipfelhang. Hier kann schiüblich in der Scharte schon das Panorama genossen werden, oder es führt leichte Kletterei im 2. Grat auf den Hauptgipfel. Ungefähr entlang des Aufstiegs geht es auf Schiern zum Auto zurück.",
    price: "ab € 490,00",
    prices: {
      1: "490,00", 
      2: "590,00", 
      3: "690,00",
      4: "790,00", 
    },
    inclServices: [
      "Führung im freien Gelände durch staatlich geprüften Berg- und Schiführer, Landesskilehrer und Lawinenfachmann.",
    ], 
    exclServices: [],
    equipment: "",
    date: "Spontan nach Anfrage im Winter.",
    place: "Pinzgau / Nationalpark Berchtesgaden",
    duration: "1 Tag",
    maxGuests: "4",
    overalleLevel: 3,
    levelTech: 33,
    levelTechText: "Sicheres Gehen in steilen Spitzkehren",
    levelFitness: 33, 
    levelFitnessText: "Kondition für Aufstieg von ca. 400 Hm/h",
    link: "/mountainguide",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m6_schitour_hocheisspitz/head.jpg`,
    imgOne: `${baseImagePath}mountainguide/offers/m6_schitour_hocheisspitz/IMG_7334.jpg`,
    imgTwo: `${baseImagePath}mountainguide/offers/m6_schitour_hocheisspitz/IMG_7357.jpg`,
    imgThree: `${baseImagePath}mountainguide/offers/m6_schitour_hocheisspitz/IMG_7435.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },

  {
    id: "m7",
    category: "skitour",
    country: "Österreich",
    title: "Schitour Sonnspitz, Saalbach",
    subtitle: "Sonnige Paradeschitour im Glemmtal für Genießer.",
    text_overview: "Dass das Glemmtal so perfektes Schigelände bietet ist wie so vieles den Gletschern von früher zu verdanken. Die höchsten Erhebungen der Grasberge ragten nur knapp über das Eis und bei ihrem Rückzug schliffen die Gletscher die sanften Formen der Grasberge. Die Sonnspitze ist ein solcher Berg, der ihrem Namen entsprechend einen angenehm gleichmäßigen südseitigen Schitourentag für Genießer bietet.",
    text_itinerary: "Treffpunkt ist in der Früh im Talschluss. Wir starten morgens, haben dann aber viel Zeit um uns schön langsam dem Gipfel zu nähern. Konnte man bis hierher frei die Gedanken baumeln lassen ist nun etwas Konzentration gefragt um nach wenigen steileren Metern die jedes Jahr mächtige Gipfelwechte betrachten zu können. Abfahrt in perfektem flachen Schigelände.",
    price: "ab € 450,00",
    prices: {
      1: "450,00", 
      2: "550,00", 
      3: "650,00", 
      4: "750,00", 
      5: "850,00",
    },
    inclServices: [
      "Führung im freien Gelände durch staatlich geprüften Berg- und Schiführer, Landesskilehrer und Lawinenfachmann.",
    ], 
    exclServices: [],
    equipment: "",
    date: "Spontan nach Anfrage im Winter.",
    place: "Saalbach-Hinterglemm, Salzburg",
    duration: "1 Tag",
    maxGuests: "5",
    overalleLevel: 1,
    levelTech: 11, 
    levelTechText: "Gehen mit Schitourenausrüstung",
    levelFitness: 22,
    levelFitnessText: "Kondition für Aufstieg von ca. 300 Hm/h",
    link: "/mountainguide",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m7_schitour_sonnspitz/head.jpg`,
    imgOne: `${baseImagePath}mountainguide/offers/m7_schitour_sonnspitz/CIMG2490.jpg`,
    imgTwo: `${baseImagePath}mountainguide/offers/m7_schitour_sonnspitz/CIMG6275.jpg`,
    imgThree: `${baseImagePath}mountainguide/offers/m7_schitour_sonnspitz/IMG_2463.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },
  {
    id: "m8",
    category: "skitour",
    country: "Österreich",
    title: "Schitour Staffkogel, Saalbach",
    subtitle: "Paradeschitour im Glemmtal für genießerische Könner.",
    text_overview: "Der Staffkogel bietet als mächtiger Klotz den Abschluss des Tals in diese Richtung. Sanfte Hänge führen in raumgreifender Linienführung zu einem Durchschlupf am Berg der auf das obere Plateau leitet. Am Gipfelhang wird es kurz steiler, worauf wir mit einem tollen Panorama über die Stein-, Gras-, und Gletscherberge begrüßt werden. Abfahrt in perfektem mittelsteilen Schigelände mit einem kurzen technischen Waldstück am Schluss.",
    text_itinerary: "Treffpunkt im Talschluss und Aufwärmen beim Aufstieg in Richtung Lindlingalm. Durch erst bewaldete dann freie Hänge geht es einige Stunden zum Gipfel des Staffkogel, einem der auffälligeren Berge im Glemmtal. Nachdem wir in der Exposition bei der Abfahrt ein wenig variieren können, sowohl was Steilheit als auch was Sonneneinstrahlung betrifft, finden wir hoffentlich guten Schnee um das perfekte Schigelände genießen zu können.",
    price: "ab € 450,00",
    prices: {
      1: "450,00", 
      2: "550,00", 
      3: "650,00", 
      4: "750,00", 
      5: "850,00",
    },
    inclServices: [
      "Führung im freien Gelände durch staatlich geprüften Berg- und Schiführer, Landesskilehrer und Lawinenfachmann.",
    ], 
    exclServices: [],
    equipment: "",
    date: "Spontan nach Anfrage im Winter.",
    duration: "1 Tag",
    place: "Saalbach-Hinterglemm, Salzburg",
    maxGuests: "5",
    overalleLevel: 2,
    levelTech: 22, 
    levelTechText: "Sicheres Gehen in Spitzkehren",
    levelFitness: 22, 
    levelFitnessText: "Kondition für Aufstieg von ca. 300 Hm/h",
    link: "/mountainguide",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m8_schitour_staffkogel/CIMG2509.jpg`,
    imgOne: `${baseImagePath}mountainguide/offers/m8_schitour_staffkogel/head.jpg`,
    imgTwo: `${baseImagePath}mountainguide/offers/m8_schitour_staffkogel/CIMG2507.jpg`,
    imgThree: `${baseImagePath}mountainguide/offers/m8_schitour_staffkogel/IMG_2265.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  }, 
  {
    id: "m9",
    category: "hochtourEast",
    country: "Österreich",
    title: "Großer Möseler Westsporn",
    subtitle: "Einsteiger-Hochtour mit leichtem Klettern und leichtem Gletscher in den Zillertaler Alpen.",
    text_overview: "Diesen Paradeberg im hinteren Zillertal zeichnet aus, dass der Normalweg über einen äußerst hübschen Sporn führt der die Schwierigkeiten nochdazu überschaubar hält. Jedoch bietet er ausgezeichnetes Gelände um der hochalpinen Landschaft näher zu kommen, von Blockgrat über Querungen im Firn und kleinen heikleren Stellen ist bis zum hoch oben eingelagerten Gletscherfeld und - je nach Jahreszeit - Gipfelwechte alles dabei.",
    text_itinerary: "Tag 1: Vom Schlegeis steigen wir zum Furtschagelhaus auf, einer eher kleinen und sympathischen Hütte im Herzen der Alpen. Sie ist ein idealer Ausgangspunkt für unseren Berg da wir direkt im Angesicht sind und im Vergleich zu ähnlichen Touren gestaltet sich der Zustieg eher kurz. Tag 2: Relativ kurzer Gletscherzustieg zum Sporn. Ab dann je nach Jahreszeit leichte kombinierte Kletterei bis zum oberen flachen Gletscher und dem kleinen Gipfelausschwung. Ein atemberaubendes Panorama eröffnet uns viele der großen Berge der Alpen.",
    price: "ab € 730,00",
    prices: {
      1: "730,00", 
      2: "830,00", 
      3: "930,00"  
    },
    inclServices: [
      "Führung durch staatlich geprüften Bergführer",
       "Leihausrüstung nach Bedarf",
    ], 
    exclServices: [
      "Hüttenkosten", 
      "Spesen des Bergführers (Halbpension, Parkgebühren)",
      "Ausrüstung: Wir schicken Dir bei Buchung eine Ausrüstungsliste.",
    ],
    equipment: "",
    date: "Spontan nach Anfrage, und auch als Schitour möglich.",
    duration: "1,5 Tage",
    place: "Zillertaler Alpen, Tirol",
    maxGuests: "3",
    overalleLevel: 2,
    levelTech: 22,
    levelTechText: "Gutes Gleichgewicht im leichten Gelände",
    levelFitness: 33, 
    levelFitnessText: "Hochtour mit Übernachtung",
    link: "/mountainguide",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m9_moeseler/head.jpg`,
    imgOne: `${baseImagePath}mountainguide/offers/m9_moeseler/IMG_4033.jpg`,
    imgTwo: `${baseImagePath}mountainguide/offers/m9_moeseler/IMG_4050.jpg`,
    imgThree: `${baseImagePath}mountainguide/offers/m9_moeseler/IMG_4080.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  }, 
{
  id: "m10",
  category: "hochtourEast",
  country: "Österreich",
  title: "Großes Wiesbachhorn 'Kaindlgrat'",
  subtitle: "Geschichtsträchtiger Firngrat inmitten der Tauernriesen.",
  text_overview: "Das Große Wiesbachhorn ist von allen Seiten ein fantastischer Berg, dessen einzigartig formschöne Silhouette von allen großen Tauerngipfeln aus ins Auge fällt.", 
  text_itinerary: "Tag 1: Wir treffen uns am Heinrich Schwaiger Haus über dem Moserboden, der mit Bussen erreicht werden kann. Kennenlernen beim Abendessen und anschließende Tourenbesprechung mit Materialcheck. Tag 2: Aufstieg zum Großen Wiesbachhorn mit leichten Kletterstellen, einem Firngrat (je nach Verhältnissen) und Blockgelände.",
  price: "ab € 730,00",
  prices: {
    1: "730,00", 
    2: "740,00", 
    3: "810,00"
  },
  inclServices: [
    "Führung durch staatlich geprüften Bergführer",
     "Leihausrüstung nach Bedarf",
  ], 
  exclServices: [
    "Hüttenkosten",
    "Maut",
    "Spesen des Bergführers (Halbpension)",
    
  ],
  equipment: [
    "Kletterschuhe",
    "Ausrüstung: Wir schicken Dir bei Buchung eine Ausrüstungsliste.",
  ],
  date: "Spontan nach Anfrage.",
  duration: "1,5 Tage",
  place: "Hohe Tauern, Salzburg",
  maxGuests: "3",
  overalleLevel: 3,
  levelTech: 22, 
  levelTechText: "Etwas Erfahrung im Steigeisengehen und mit Felskontakt",
  levelFitness: 33, 
  levelFitnessText: "Hochtour mit Übernachtung",
  link: "/mountainguide",
  isNew: true,

  imgHead: `${baseImagePath}mountainguide/offers/m10_wiesbachhorn_kaindlgrat/head.jpg`,
  imgOne: `${baseImagePath}mountainguide/offers/m10_wiesbachhorn_kaindlgrat/IMG_1166.jpg`,
  imgTwo: `${baseImagePath}mountainguide/offers/m10_wiesbachhorn_kaindlgrat/IMG_1184.jpg`,
  imgThree: `${baseImagePath}mountainguide/offers/m10_wiesbachhorn_kaindlgrat/IMG_1188.jpg`,

  descrImgOne: "",
  descrImgTwo: "",
  descrImgThree: "",
},

{
id: "m11",
category: "hochtourEast",
country: "Österreich",
title: "Glocknerwand-Überschreitung",
subtitle: "Die vermutlich großartigste Gratüberschreitung der Ostalpen.",
text_overview: "Die Glocknerwandüberschreitung ist eine großzügige anspruchsvolle Überschreitung mit Westalpencharakter. Inmitten der hochalpinsten Landschaft weit und breit ragt diese Felsrippe vom Gletscher empor und führt über spannende Zacken und Gipfel zum höchsten Punkt Österreichs, dem Großglockner.",
text_itinerary: "Tag 1: Wir treffen uns auf der Stüdlhütte, die leicht über einen markierten breiten Wanderweg erreichbar ist. Hier kontrollieren wir das Material und ergänzen wo nötig. Die Tour macht eine gutes Gespräch zum Ablauf nötig. Tag 2: In der Früh Gletscherzustieg. Ab dem Einstieg zählt man üblicherweise 11 Gipfel über 3000 m die in mehrstündiger Kletterei überwunden werden mit ihrem Höhepunkt am Großglockner, dem höchsten Berg Österreichs. Am Normalweg geht es zurück zur Stüdlhütte um spätabends eine der größten Überschreitungen der Ostalpen geschafft zu haben: Über die Glocknerwand auf den Großglockner.",
price: "ab € 890,00",
prices: {
  1: "890,00"
},
inclServices: [
  "Führung durch staatlich geprüften Bergführer",
   "Leihausrüstung nach Bedarf",
], 
exclServices: [
  "Hüttenkosten", 
  "Spesen des Bergführers (Halbpension, Parkgebühren)",
],
equipment: "Ausrüstung: Wir schicken Dir bei Buchung eine Ausrüstungsliste.",
date: "Spontan nach Anfrage.",
duration: "1,5 Tage",
place: "Hohe Tauern, Salzburg",
maxGuests: "1",
overalleLevel: 4,
levelTech: 33,
levelTechText: "Sicheres Klettern im 4. Grad über längere Passagen",
levelFitness: 44,
levelFitnessText: "Hochtour mit Übernachtung",
imgHead: `${baseImagePath}mountainguide/offers/m11_glocknerwandueberschreitung/head.jpg`,
imgOne: `${baseImagePath}mountainguide/offers/m11_glocknerwandueberschreitung/IMG_6310.jpg`,
imgTwo: `${baseImagePath}mountainguide/offers/m11_glocknerwandueberschreitung/IMG_6326.jpg`,
imgThree: `${baseImagePath}mountainguide/offers/m11_glocknerwandueberschreitung/IMG_6343.jpg`,
link: "/mountainguide",
isNew: true,
}, 

{
id: "m12",
category: "hochtourEast",
country: "Österreich",
title: "Dreiherrnspitz 'Grasleitenschneid'",
subtitle: "Einsame wilde Gratbegehung am Dreiländereck Salzburg - Tirol - Südtirol.",
text_overview: "Wem am Glockner oder Großvenediger zu viel los ist der findet auf diesem Grat komplett andere Bedingungen vor; kaum, dass man von Begehungen erfährt. Dies liegt nicht an der fehlenden Großartigkeit des Anstiegs, sondern am gehobenen Anspruch was das Bewegen im alpinen Gelände betrifft. Lässt man sich von dieser alpinromantischen Art des Steigens nicht einschüchtern wartet eine eingelagerte Gratschneide mit bestem Fels auf die vereinzelten Wiederholer. Ein Gletscherfleck hoch oben am Grat und der Abstieg über das Prettau-Kees machen aus dieser Tour eine ausgewachsene Unternehmung.",
text_itinerary: "Tag 1: Treffpunkt auf der Birnlückenhütte die leicht auf markiertem Weg erwandert wird. Hier übernachten wir mit den den Abschnitten des morgigen Tages im Abendpanorama aufgereiht. Tag 2: Bergsteigerisch interessantes Gelände führt uns erst entlang einer flachen Rippe, die in ihrem Verlauf immer wilder und zerklüfteter wird. Nicht jeder Meter ist klar vorgegeben und der Fels ist kein Stück abgeklettert, was hohe Ansprüche an die Konzentration stellt. Haben wir die ersten schwierigeren Abbrüche überwunden dürfen wir etwas befreiter klettern auf einem eingelagertem Wandl und dann dem perfekten spaßigen Urgestein-Grat der uns für die Mühen belohnt. Ein Stück flacheres aber ebenso alpines Gelände trennt uns noch vom Gipfel am Dreiländereck. Abstieg über den Gletscher zurück zur Birnlücke.",
price: "ab € 790,00",
prices: {
  1: "790,00",
},
inclServices: [
  "Führung durch staatlich geprüften Bergführer",
   "Leihausrüstung nach Bedarf",
], 
exclServices: [
  "Hüttenkosten", 
  "Spesen des Bergführers (Halbpension, Parkgebühren)",
],
equipment: "Ausrüstung: Wir schicken Dir bei Buchung eine Ausrüstungsliste.",
date: "Spontan nach Anfrage im Sommer und Herbst.",
duration: "1,5 Tage",
place: "Hohe Tauern, Salzburg",
maxGuests: "1",
overalleLevel: 4,
levelTech: 33,
levelTechText: "Sicheres Bewegen in heiklem Gelände, Klettern bis 3",
levelFitness: 33,
levelFitnessText:"Hochtour mit Übernachtung",
link: "/mountainguide",
isNew: true,

imgHead: `${baseImagePath}mountainguide/offers/m12_dreiherrnspitz_grasleitenschneid/head.jpg`,
imgOne: `${baseImagePath}mountainguide/offers/m12_dreiherrnspitz_grasleitenschneid/IMG_2029.jpg`,
imgTwo: `${baseImagePath}mountainguide/offers/m12_dreiherrnspitz_grasleitenschneid/IMG_1992.jpg`,
imgThree: `${baseImagePath}mountainguide/offers/m12_dreiherrnspitz_grasleitenschneid/IMG_1994.jpg`,

descrImgOne: "",
descrImgTwo: "",
descrImgThree: "",
}, 


];

export default offers;


  /* 
   {
     id: "a1",
    category: "",
    title: "",
    subtitle: "",
    text_overview: "", 
    text_itinerary: "",
    price: "ab € 000,00",
    prices: {
      1: 750, 
      2: 900  
    },
    inclServices: [], 
    exclServices: [],
    equipment: "",
    date: "",
    duration: "",
    place: "",
    maxGuests: "",
    overalleLevel: ,
    levelTech: ,
    levelTechText: "",
    levelFitness: ,
    levelFitnessText: "",
    link: "/mountainguide",
    isNew: true,

    imgHead: `${baseImagePath}mountainguide/offers/m1_Traunspitzl_Neue_Zeiten/IMG_7534_head.jpg`,
    imgOne: '',
    imgTwo: '',
    imgThree: '',
    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
    }
  */

